const canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);

export default canUseDOM;



// WEBPACK FOOTER //
// ./app/lib/util/canUseDOM.js